export interface ContactPayload {
  message: string;
}

export enum ContactActionTypes {
  SEND_REQUEST = "@Contact/SEND_REQUEST",
  SEND_SUCCESS = "@Contact/SEND_SUCCESS",
  SEND_FAILURE = "@Contact/SEND_FAILURE",
}
